import React, {useEffect, useRef, useState} from "react";
import mapboxgl from 'mapbox-gl';
import { makeStyles } from '@material-ui/core/styles';
import { createPortal } from "react-dom";
import MarcadorGoT from "./Marcador2";
import 'mapbox-gl/dist/mapbox-gl.css';
import Popup from "./popup";
const useStyles = makeStyles({
    miclase:{".map-container":{
        height: "400px",
      }},
  });
  let arregloReg=[
    {  // region:1,
        pos:["001", "003", "026", "045","056","071","079","102", "112"],
        auxColor: process.env.REACT_APP_Fondo_Color
    }, 
    {   //region:2,
        pos:["014" ,"042", "047", "048","064","074","085","124"],
        "auxColor": process.env.REACT_APP_Fondo_Color
    },
 
]

function Mapa({registro,}) {

    
    const classes = useStyles();
    const mapContainer = useRef(null);
    const mapRef = useRef(null);
    const markerRef = useRef()
    const [long] = useState(-101.3899294); 
    const [lat] = useState(23.4943939);
    const [zoom] = useState(12);
    const [regisMarca, setRegisMarca] = useState([]);
    const [regisPopUp, setRegisPopUp] = useState([]);
    const [hoveredDistrict, _setHoveredDistrict] = useState(null);
    //const hoveredDistrictRef = useRef(hoveredDistrict);
    //console.log(mapaGeOJson);
    let hoveredStateId = null;
    let stateName = null;

  /*   const popup = new mapboxgl.Popup({
        closeButton: false,
        closeOnClick: false
    }); */

    useEffect(() => {       
 
     //console.log(registro);
     mapboxgl.accessToken = process.env.REACT_APP_MAPBOX_KEY;
        mapRef.current = new mapboxgl.Map({
            container: mapContainer.current,
            style: "mapbox://styles/mapbox/light-v10",
            center: [registro.long, registro.lat],
            zoom: zoom            
        });
        const geometry = { coordinates:[registro.long, registro.lat] } 
        const properties = {texto:registro.original.Descr}
        setRegisMarca({geometry,properties})
        setRegisPopUp([])
        //mapRef.addControl(new mapboxgl.NavigationControl());
 
        return () => {
            mapRef.current.remove()
        }
    }, [registro]);


    const onClick=(aux)=>{
        

        setRegisPopUp(aux)
    }

    return (
    <div className={classes.miclase} style={{width:900,height: "15rem"}} >
       
        {<div id="districtDetailMap" className={"map"} >
            <div style={{width:900,height: 450}} ref={mapContainer}>
            </div>
            {   registro.length!==0 && regisMarca.length !== 0 ?
               <MarcadorGoT
                    key={1}
                    map={mapRef.current}
                    feature={regisMarca}
                    onClick={onClick}
                /> 
          :null  }
           {mapRef.current && regisPopUp.length!==0 ? (
                <Popup
                    map={mapRef.current}
                    activeFeature={regisPopUp}
                />
            )
            :null}
        </div>}
    </div>
    );
}

export default Mapa;